export const NEAR_ZERO_3 = 1e-3; // 1 × 10⁻³, i.e. 0.001
export const NEAR_ZERO_4 = 1e-4; // 1 × 10⁻⁴, i.e. 0.0001
export const NEAR_ZERO_5 = 1e-5; // 1 × 10⁻⁵, i.e. 0.00001
export const NEAR_ZERO_6 = 1e-6; // 1 × 10⁻⁶, i.e. 0.000001

export const TAU = Math.PI * 2; // TAU (τ) is a full circle in radians — 2π
